module.exports = __webpack_public_path__ + "img/logo_akorn_pharmaceuticals.75b8bed2.png";